import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import NoData from "../../components/Nodata";

import api from "../../services/api";

const Dashboard = () => {
  const [users, setUsers] = useState(0);
  const [customers, setCustomers] = useState(0);
  const [visits, setVisits] = useState(0);
  const [study, setStudy] = useState(0);
  const [other, setOther] = useState(0);
  const [revenue, setRevenue] = useState(0);
  const [received, setReceived] = useState(0);
  const [incentives, setIncentives] = useState(0);
  const [filters, setFilters] = useState({
    startDate: new Date(new Date().setDate(1)),
    endDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, [filters]);

  const getData = async (e) => {
    try {
      setLoading(true);
      const { data: cstmrs } = await api.post("customer/stats", filters);
      setCustomers(cstmrs.total);
      setVisits(cstmrs.total_visit);
      setStudy(cstmrs.total_study);
      setOther(cstmrs.total_other);

      const { data: allC } = await api.post("customer/search", filters);

      const rvn = (allC.customers || []).reduce(
        (acc, c) =>
          acc +
          (c.services || []).reduce((sacc, s) => sacc + parseInt(s.fee), 0) +
          c.visa_fee +
          c.embassy_fee +
          c.appointment_fee +
          c.hotel_fee +
          c.ticket_fee +
          c.insurance_fee,
        0
      );

      setRevenue(rvn);

      const { data: allP } = await api.post("payment/search", filters);

      const rcvd = (allP.payments || []).reduce((acc, c) => acc + c.amount, 0);

      setReceived(rcvd);

      const { data: allI } = await api.post("incentive/search", filters);

      const incnt = (allI.incentives || []).reduce(
        (acc, c) => acc + c.amount,
        0
      );

      setIncentives(incnt);

      const { data: users } = await api.post("user/stats", filters);
      setUsers(users.total);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="loader">Loading...</div>
      </div>
    );
  }

  return (
    <div className="p-5">
      {/* Dashboard Title */}
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold mb-6">Revenue Summary</h1>

        <DatePicker
          selected={filters.startDate}
          value={new Date(filters.startDate).toLocaleDateString([], {
            month: "long",
          })}
          onChange={(startDate) => {
            const date = new Date(startDate);
            setFilters({
              ...filters,
              startDate: new Date(startDate.setDate(1)),
              endDate: new Date(date.setMonth(date.getMonth() + 1)),
            });
          }}
          className="cursor-pointer block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
          showMonthYearPicker
          calendarClassName="bg-white border border-gray-200 shadow-lg rounded-lg p-2"
        />
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
        <div class="bg-white p-4 rounded-2xl shadow-md">
          <h2 class="text-sm font-semibold text-gray-700">Total Revenue</h2>
          <div class="mt-1 text-3xl font-bold">
            {formatAmount(revenue)} <span className="text-gray-300 ">PKR</span>
          </div>
        </div>
        <div class="bg-white p-4 rounded-2xl shadow-md">
          <h2 class="text-sm font-semibold text-gray-700">Total Received</h2>
          <div class="mt-1 text-3xl font-bold">
            {formatAmount(received)} <span className="text-gray-300 ">PKR</span>
          </div>
        </div>
        <div class="bg-white p-4 rounded-2xl shadow-md">
          <h2 class="text-sm font-semibold text-gray-700">Total Pending</h2>
          <div class="mt-1 text-3xl font-bold">
            {formatAmount(revenue - received)}{" "}
            <span className="text-gray-300 ">PKR</span>
          </div>
        </div>
      </div>
      {/* Tables Section */}
      <div>
        <RecentCustomers filters={filters} />
      </div>
    </div>
  );
};

export default Dashboard;

const RecentCustomers = ({ filters }) => {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    getData();
  }, [filters]);

  const getData = async (e) => {
    try {
      const { data } = await api.post("customer/search", {
        ...filters,
        sortBy: "created_at",
        limit: 10,
      });
      setCustomers(data.customers);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h3 className="text-lg font-bold text-gray-800 mb-4">Customers</h3>
      <table className="w-full text-left border-collapse">
        <thead>
          <tr>
            <th className="border-b py-2 text-sm text-gray-600">Name</th>
            <th className="border-b py-2 text-sm text-gray-600">Category</th>
            <th className="border-b py-2 text-sm text-gray-600">Payment</th>
            <th className="border-b py-2 text-sm text-gray-600">Date</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr key={customer.id}>
              <td className="border-b text-sm py-2 px-2">{customer.name}</td>
              <td className="border-b text-sm py-2 px-2">
                {customer.category}
              </td>
              <td className="p-2 py-3 text-gray-600">
                <div className="text-xs pt-2">
                  <p className="flex items-center justify-between">
                    Total:{" "}
                    <strong>
                      {(customer.total_amount || 0).toLocaleString()}{" "}
                      <span className="font-normal">PKR</span>
                    </strong>
                  </p>
                  <p className="flex items-center justify-between">
                    Paid:{" "}
                    <strong>
                      {(customer.paid_amount || 0).toLocaleString()}{" "}
                      <span className="font-normal">PKR</span>
                    </strong>
                  </p>
                  <p className="flex items-center justify-between">
                    Balance:{" "}
                    <strong>
                      {(
                        customer.total_amount - customer.paid_amount || 0
                      ).toLocaleString()}{" "}
                      <span className="font-normal">PKR</span>
                    </strong>{" "}
                  </p>
                </div>
              </td>

              <td className="border-b text-sm py-2 px-2">
                {new Date(customer.created_at).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!customers.length && <NoData />}
    </div>
  );
};

function formatAmount(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
